/* eslint-disable no-param-reassign */
function isString(str: unknown): str is string {
  return typeof str === 'string' || Object.prototype.toString.call(str) === '[object String]'
}

function strLimit(str: string, limit?: number, dots?: string) {
  if (!isString(str)) {
    return ''
  }

  if (!str) return str

  if (!limit) {
    limit = 100 as number
  }

  if (!dots && dots !== '') {
    dots = '..' as string
  }

  if (str.length > limit) str = (str.substring(0, limit) + dots) as string

  return str
}

function getInitialName(string: string) {
  const names = string.split(' ')
  let initials = names[0].substring(0, 1).toUpperCase()

  if (names.length > 1) {
    initials += names[names.length - 1].substring(0, 1).toUpperCase()
  }
  return initials
}

export { strLimit, getInitialName }
